/** `true` si `url` es una URL absoluta `http`/`https` (a dónde se puede mandar al usuario al guardar o salir). */
export function isValidRedirectUrl(url: string | null | undefined): boolean {
    if (!url || typeof url !== 'string' || url.trim() === '') {
        return false;
    }

    try {
        const parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
}
